export enum FeatureFlags {
  ENABLE_AO_FINANCIALS = 'ENABLE_AO_FINANCIALS',
  ENABLE_NEWS = 'ENABLE_NEWS',
  ENABLE_SEARCH_BY_THEME = 'ENABLE_SEARCH_BY_THEME',
  ENABLE_SCREENER_KEY_DEVELOPMENTS = 'ENABLE_SCREENER_KEY_DEVELOPMENTS',
  CALENDAR = 'CALENDAR',
}

export interface Flags {
  [key: string]: boolean | undefined;
}

export type FeatureFlagsKeys = keyof Flags;
